import React from "react"
import Protected from "../Protected"
import { Link } from "react-router-dom"
import { PATHS } from "../Routes"
import { MainArticleLayout } from "../../layouts/MainArticleLayout"
import { Button } from "semantic-ui-react"

const ResetPasswordLanding = () => {
    const navigateToResetPassword = () => {
        window.location.href = process.env.B2C_CHANGE_PASSWORD_URL
      }
    return (
        <>
            <Protected>
                <nav className="breadcrumbs dnd-s-mob">
                    <ol>
                        <li>
                            <Link className="underline" to={PATHS.Profile}>
                                Back to previous page
                            </Link>
                        </li>
                    </ol>
                </nav>
                <div>
                    <MainArticleLayout>
                        <h1>Change password</h1>
                        <p></p>
                        <>Click on the button to log out and change your password</>

                        <div className="button-group is-right">
                            <Button
                                type="submit"
                                className="is-primary"
                                onClick={()=> navigateToResetPassword()}

                            >
                                Change password
                            </Button>
                            <Button
                                as={Link}
                                to={PATHS.Profile}
                                type="button"
                                content="Cancel"
                                className="is-secondary"
                            />
                        </div>
                    </MainArticleLayout>
                </div>
            </Protected>
        </>
    )


}
export default ResetPasswordLanding